import client from '../client'

export async function changeCommunicationPreferences({
  letEmail,
  letPromotional,
  letSavedVehicleUpdate,
  letYourVehicleAuction,
  letYourVehicleBid,
  letBuyNowUpdate,
  letOfferUpdate,
}) {
  return client(
    `${process.env.NEXT_PUBLIC_NOTIFICATIONS_DOMAIN}/api/UserAccounts/ChangeCommunicationPreference`,
    {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        communicationPreference: {
          letEmail,
          letPromotional,
          letSavedVehicleUpdate,
          letYourVehicleAuction,
          letYourVehicleBid,
          letBuyNowUpdate,
          letOfferUpdate,
        },
      }),
    },
  )
}
